// client/src/coms/voip/participantPrefs.js

const STORAGE_KEY = 'pa_coms_voice_participant_prefs_v1';

function safeParseJson(s) {
  try {
    return JSON.parse(s);
  } catch {
    return null;
  }
}

function readStore() {
  if (typeof window === 'undefined') return {};
  const raw = window.localStorage ? window.localStorage.getItem(STORAGE_KEY) : '';
  const parsed = safeParseJson(raw);
  return parsed && typeof parsed === 'object' ? parsed : {};
}

function writeStore(store) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage && window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {}
}

function clampInt(n, min, max) {
  const x = Number(n);
  if (!Number.isFinite(x)) return min;
  const i = Math.round(x);
  return Math.max(min, Math.min(max, i));
}

export function buildParticipantKey(serverId, participantId) {
  const sid = String(serverId || '').trim();
  const pid = String(participantId || '').trim();
  if (!sid || !pid) return '';
  return `${sid}:${pid}`;
}

export function buildParticipantNameKey(serverId, participantName) {
  const sid = String(serverId || '').trim();
  const name = String(participantName || '').trim();
  if (!sid || !name) return '';
  return `${sid}:name:${name}`;
}

export function getParticipantPrefs({ serverId, participantId, participantName }) {
  const store = readStore();

  const key = buildParticipantKey(serverId, participantId);
  const nameKey = buildParticipantNameKey(serverId, participantName);

  const hit = (key && store[key]) || (nameKey && store[nameKey]) || null;

  if (!hit) {
    return { volume: 100, muted: false };
  }

  const volume = clampInt(hit.volume, 0, 100);
  const muted = !!hit.muted;

  return { volume, muted };
}

export function setParticipantPrefs({ serverId, participantId, participantName, volume, muted }) {
  const store = readStore();

  const v = clampInt(volume, 0, 100);
  const m = !!muted;

  const key = buildParticipantKey(serverId, participantId);
  const nameKey = buildParticipantNameKey(serverId, participantName);

  const payload = { volume: v, muted: m };

  if (key) store[key] = payload;
  if (nameKey) store[nameKey] = payload;

  writeStore(store);

  try {
    window.dispatchEvent(
      new CustomEvent('pa-coms-voice-participant-prefs-changed', {
        detail: {
          serverId: String(serverId || ''),
          participantId: String(participantId || ''),
          participantName: String(participantName || ''),
          volume: v,
          muted: m,
        },
      })
    );
  } catch {}

  return payload;
}
